import React from 'react';

export const AvailableBlurEffectStyles   = [];
export const AvailablePresentationStyles = [];


export class ModalView extends React.PureComponent {
  render(){
    return(
      null
    );
  };
};